import { module } from "angular";
import { SortConfigurationGroupsByType } from "./SortingFilters";

module("mmGui").filter("irSortConfGroups", SortConfigurationGroupsByType);
